import { useEffect, useReducer } from 'react'

import { useGuaranteedScid } from 'common/use-scid'

import PremiumInsightsContext from './Context'
import getCollegePremiumInsights from './getCollegePremiumInsights'
import { INITIAL_STATE, reducer } from './reducer'

const PremiumInsightsProvider = ({ children }: { children: React.ReactNode }) => {
  const scid = useGuaranteedScid()
  const [state, dispatch] = useReducer(reducer, INITIAL_STATE)

  useEffect(() => {
    getCollegePremiumInsights({
      scid,
      audience: state.selectedFilters.audience,
      bucket: state.selectedFilters.bucket,
      dispatch,
    })
  }, [scid, state.selectedFilters.audience, state.selectedFilters.bucket, dispatch])

  return (
    <PremiumInsightsContext.Provider
      value={{
        ...state,
        dispatch,
      }}
    >
      {children}
    </PremiumInsightsContext.Provider>
  )
}

export default PremiumInsightsProvider
